import React from 'react';
import {Form} from '../../../stores/Form';
import {Button, PriorityIcon, Text} from '@priority-software/priority-style-react';
import {EmptyStateComponent} from '../../../components/Common/EmptyState/EmptyState';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import emptyStateTexts from '../../../components/Common/EmptyState/texts';
import emptyState from '../../../images/emptyState.png';
import emptyStateAdd from '../../../images/emptyStateAdd.svg';

export function NoRecordsToShow(props: {createNewRow?: () => void}) {
    const {createNewRow} = props;

    return (
        <>
            <Text skin="subtitle-1">{emptyStateTexts.filterDataMessage}</Text>
            <Text skin="subtitle-1">{emptyStateTexts.addNewMessage}</Text>
            <Button prefixIcon={PriorityIcon.addSmall} onClick={createNewRow}>
                {getLocalizedText(texts.newTxt)}
            </Button>
        </>
    );
}

export const EmptyState = ({form, createNewRow}: {form: Form; createNewRow?: () => void}) => {
    const hasFilters = form.filters.length > 0;
    const title = hasFilters ? emptyStateTexts.noResults : emptyStateTexts.noRecords;
    const message = hasFilters ? (
        emptyStateTexts.moreResultsMessage
    ) : (
        <NoRecordsToShow createNewRow={createNewRow} />
    );
    const image = hasFilters ? emptyState : emptyStateAdd;

    const openAISearch = () => {
        form.searchStore.openNewSearch(true);
    };

    return (
        <EmptyStateComponent
            title={title}
            message={message}
            image={image}
            openAISearch={openAISearch}
        />
    );
};
